<template>
<div v-if ="signPeopleInfo" class="tab-wrapper">
  <h3>基本信息</h3>
  <div class="content">
    <p>
      <span class="label">姓名：</span>
      <span class="info">{{signPeopleInfo.signName}}</span>
    </p>
    <p>
      <span class="label">手机：</span>
      <span class="info">{{signPeopleInfo.userPhone?signPeopleInfo.userPhone : " "}}</span>
    </p>
    <p>
      <span class="label">证件类型：</span>
 
      <span class="info">{{signPeopleInfo.certificatesTypeName ? signPeopleInfo.certificatesTypeName : " "}}</span>
    </p>
    <p>
      <span class="label">证件号：</span>
      <span class="info">{{signPeopleInfo.certificatesCode ? signPeopleInfo.certificatesCode : " " }}</span>
    </p>
    <p>
      <span class="label">性别：</span>
      <span class="info">{{ signPeopleInfo.signGender === 1? "女": signPeopleInfo.signGender === 2 ?"男":" " }}</span>
    </p>

    <p>
      <span class="label">生日：</span>
      <span class="info">{{signPeopleInfo.brithDate}}</span>
    </p>
    <p>
      <span class="label">职业：</span>
      <span class="info">{{signPeopleInfo.workType}}</span>
    </p>
    
    <p>
      <span class="label">国籍：</span>
      <span class="info">{{signPeopleInfo.signNationality}}</span>
    </p>
    <p>
      <span class="label">婚姻状况：</span>
      <span class="info">{{signPeopleInfo.marriageStatusName}}</span>
    </p>
    <div>
      <span class="label">证件照片：</span>
      <div class="img-wrap"><img class="file-img" :src="signPeopleInfo.certUrl1" @click.stop="showImg(signPeopleInfo.certUrl1)" alt="证件照片"></div>
      <div class="img-wrap"><img class="file-img" :src="signPeopleInfo.certUrl2" @click.stop="showImg(signPeopleInfo.certUrl2)" alt="证件照片"></div>
    </div>
    <p v-if="signPeopleInfo.contactsRelateName">
      <span class="label">紧急联系人：</span>
      <span class="info">{{`${signPeopleInfo.contactsRelateName}-${signPeopleInfo.contactsName}-${signPeopleInfo.contactsPhone}`}}</span>
    </p>
  </div>

</div>
 
</template>
 
<script type="text/ecmascript-6">
export default {
  props:{
    signPeopleInfo: {
      type:Object,
      default:null
    }
  },
 data () {
 return {
 
 };
 },
 methods:{
    showImg(src) {
        this.$emit('showimg', src)
      }
 }
}
</script>
<style scoped>
h3{
  margin-bottom: 16px;
}
h4 {
  margin-bottom: 8px;
}
.label {
  display: inline-block;
  text-align: right;
  width: 72px;
}
.info {
  padding-left: 20px;
  font-weight: 600;
}

p {
  line-height: 2.5;
}
.img-wrap {
  display: inline-block;
  vertical-align: text-top;
  padding-left:20px;
}
 .file-img {
    width: 150px;
    height: 100px;
    overflow: hidden;
    display: inline-block;
    /*margin-bottom: 20px;*/
  }
</style>

